import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AdminQNA, COURSE_TAB, QnaResult, TabItem, UntilDestroy, untilDestroyed } from '@shared';
import { CourseService } from '@shared/services';
import { combineLatest } from 'rxjs';
import { Logger, MilkdownViewerComponent, RouterStoreService } from 'thkee-common';
import { CourseHeaderComponent } from '../components/course-header/course-header.component';
import { CourseHeadingComponent } from '../components/course-heading/course-heading.component';
import { TabMenuComponent } from '../../../@shared/components/tab-menu/tab-menu.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DrawerComponent } from '../../../@shared/components/drawer/drawer.component';
import { HistoryCourseComponent } from '../../../@shared/components/feedback/history-course/history-course.component';
import { DatePipe } from '@angular/common';
const log = new Logger('CourseDetailsComponent');

@UntilDestroy()
@Component({
    selector: 'app-qa',
    templateUrl: './qa.component.html',
    styleUrls: ['./qa.component.scss'],
    imports: [CourseHeaderComponent, CourseHeadingComponent, TabMenuComponent, AngularSvgIconModule, DrawerComponent, HistoryCourseComponent, DatePipe, MilkdownViewerComponent]
})
export class CourseQAComponent implements OnInit {
  private store = inject(Store);
  private courseService = inject(CourseService);
  private routerStore = inject(RouterStoreService);

  courseState: string = '3';
  qna_lists!: Partial<AdminQNA>;

  courseId: string = '';
  isShowAllReply: boolean[] = [];
  tabItems: TabItem[] = COURSE_TAB;

  ngOnInit(): void {
    combineLatest([this.routerStore.getParam('courseId')])
      .pipe(untilDestroyed(this))
      .subscribe(([courseId]) => {
        this.courseId = courseId;
        if (courseId) {
          this.getData(courseId);
        }
      });
  }

  getData(courseId: string = '') {
    this.courseService
      .getAdminCoursesQNA({}, courseId, false)
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        this.qna_lists = data;
      });
  }

  getQNAReplies(qna: QnaResult) {
    this.courseService
      .getAdminCoursesQNAReplies(qna.id)
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        // qna.QnAReply.push(...data.results);
        qna.QnAReply = data.results;
      });
  }

  showAllReply(qna: QnaResult, index: number) {
    this.isShowAllReply[index] = !this.isShowAllReply[index];
    this.getQNAReplies(qna);
  }
}
